import { NextParsedUrlQuery } from 'next/dist/server/request-meta'

function parseQuery(query: NextParsedUrlQuery, keys: string[]) {
  const result: Record<string, string> = {}
  try {
    if (keys && keys.length > 0) {
      return keys.reduce((acc, key) => {
        const queryValue = query[key]
        if (typeof queryValue === 'string') {
          acc[key] = queryValue
        } else if (Array.isArray(queryValue)) {
          acc[key] = queryValue[0]
        }
        return acc
      }, result)
    }
  } finally {
    return result
  }
}

export default parseQuery
